/**
 * User-safe messages for pass_challenge_ticket failures.
 * Maps server messages/status codes — never surfaces raw internals.
 */

const NOT_OPEN_PATTERNS = [
  'already accepted',
  'passed on',
  'canceled',
  'cancelled',
  'expired',
  'not available',
  'not open',
];

export function mapPassChallengeTicketError(err) {
  const message = String(err?.message || '').trim();
  const lower = message.toLowerCase();
  const status = err?.status;

  if (status === 401 || lower.includes('sign in')) {
    return 'Sign in to pass on this ticket.';
  }
  if (status === 404 || lower.includes('not found')) {
    return 'This challenge ticket was not found.';
  }
  if (message === 'NOT_FRIENDS') {
    return 'You must be friends with the sender to pass on this ticket.';
  }
  if (message === 'WAGER_BLOCKED') {
    return 'Passing is not available while messaging is blocked.';
  }
  if (status === 403 && lower.includes('intended recipient')) {
    return 'This ticket was sent to someone else.';
  }
  if (NOT_OPEN_PATTERNS.some((p) => lower.includes(p))) {
    return 'This challenge ticket is no longer open.';
  }
  return message || 'Could not pass on this ticket.';
}
